import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { Button } from "@material-ui/core";

import http from "../services/httpService";
import { editUserPath, searchFilter } from "../utils/varialbles";
import { useHistory, useLocation } from "react-router-dom";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchBar from "material-ui-search-bar";
import toast from "react-hot-toast";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import Paper from "@material-ui/core/Paper";

// const columns=[{name:'RM Name', type:'text', id:'Name'},
// {name:'Inv Assigned', type:'text', id:'Lead Count'},
// {name:'Inv Contacted', type:'text', id:'Calls Attempted'},
// {name:'Inv Connected', type:'text', id:'Calls Answered'},
// {name:'DNP', type:'text', id:'dnp'},
// {name:'Follow Up', type:'text', id:'follow'},
// {name:'Renewals', type:'text', id:'Total Vol'},
// {name:'AddOns', type:'text', id:''},
// {name:'Onboarding Pending', type:'text', id:''},
// {name:'Total Call Duration (mins)', type:'text', id:'duration'},
// {name:'WhatsApp Communication', type:'text', id:'WhatsApp_Count'},
// {name:'% Conversion', type:'text', id:'conv'},
// {name:'Total Val', type:'text', id:'money'},
// {name:'Reporting To', type:'select', id:'reporting'},
// {name:'RM Languages', type:'select', id:'languages'},
// {name:'Prospect Source', type:'select', id:'source'},
// {name:'', id:'status', format: "boolean"},
// ]

const columns = [
  { name: "RM Name", type: "text", id: "Name" },
  { name: "Inv Assigned", type: "text", id: "Lead Count" },
  { name: "Inv Contacted", type: "text", id: "Calls Attempted" },
  { name: "Inv Connected", type: "text", id: "Calls Answered" },
  { name: "DNP", type: "text", id: "dnp" },
  { name: "Follow Up", type: "text", id: "follow" },
  { name: "Renewals", type: "text", id: "Total Vol" },
  { name: "AddOns", type: "text", id: "Addons" },
  { name: "Onboarding Pending", type: "text", id: "pending" },
  {
    name: "Total Call Duration (mins)",
    type: "text",
    id: "Total Call Duration in mins",
    format: "decimal",
  },
  {
    name: "WhatsApp Communication",
    type: "text",
    id: "WhatsApp Communication",
  },
  { name: "% Conversion", type: "text", id: "% Conversion", format: "decimal" },
  { name: "Total Val", type: "text", id: "Total Val" },
  { name: "Reporting To", type: "select", id: "reporting", label: "reporting" },
  { name: "RM Languages", type: "select", id: "languages" },
  { name: "Prospect Source", type: "select", id: "source" },
  { name: "Action", id: "status", format: "boolean" },
];

function Executivelist() {
  const history = useHistory();
  const location = useLocation();
  const myparam = location.state;
  // const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [nameDropdown, setNameDropdown] = useState([]);
  // (nameDropdown);
  const [listData, setListData] = useState([]);
  // (listData);

  const [statFilter, setStatFilter] = useState({
    from: "",
    to: "",
    names: "",
  });

  const [showFilterExe, setShowFilterExex] = useState(false);

  var dateUrl = "";

  useEffect(() => {
    toast.loading("Please wait..");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("selectedinvestorfiltersdata");
    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
    getDashboardDatas();
  }, []);

  const getDashboardDatas = () => {
    http
      .get(`/dashboard${dateUrl}`)
      .then((res) => {
        toast.dismiss();
        if (res.data.statusCode === 0 && res.data.Data.length !== 0) {
          setListData(res.data.Data);
          setOriginalRows(res.data.Data);
          setNameDropdown(res.data.names);
        } else {
          setListData([]);
          setOriginalRows([]);
          setNameDropdown([]);
        }
        // (res.data.names);
      })
      .catch((err) => {});
    setShowFilterExex(false);
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    setPage(0);
    // setRows(searchFilter(searchedVal, rowsTemp));
    setListData(searchFilter(searchedVal, rowsTemp));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const showexefilter = () => {
    setShowFilterExex((val) => !val);
  };

  const cnacelSearch = () => {
    setShowFilterExex(false);
  };

  const dateHandleChange = (e) => {
    setStatFilter({ ...statFilter, [e.target.name]: e.target.value });
  };

  if (statFilter.from && statFilter.to && statFilter.names) {
    dateUrl = `?from=${statFilter.from}&to=${statFilter.to}&name=${statFilter.names}`;
  } else if (statFilter.from && statFilter.to) {
    dateUrl = `?from=${statFilter.from}&to=${statFilter.to}`;
  } else if (statFilter.names) {
    dateUrl = `?name=${statFilter.names}`;
  } else {
    dateUrl = "";
  }
  // (dateUrl);

  const dateHandleClear = () => {
    setStatFilter({
      from: "",
      to: "",
      names: "",
    });
    setShowFilterExex(false);
    dateUrl = "";
    toast.loading("Please wait...");
    http
      .get(`/dashboard${dateUrl}`)
      .then((res) => {
        toast.dismiss();
        // (res.data.Data);
        setListData(res.data.Data);
        setOriginalRows(res.data.Data);
        setNameDropdown(res.data.names);
      })
      .catch((err) => {});
  };

  const dateHandleApply = (e) => {
    toast.loading("Please wait...");
    http
      .get(`/dashboard${dateUrl}`)
      .then((res) => {
        toast.dismiss();
        // (res.data.Data);
        setListData(res.data.Data);
        setOriginalRows(res.data.Data);
        setNameDropdown(res.data.names);
      })
      .catch((err) => {});
    setShowFilterExex(false);
  };

  const EditUser = (e, row) => {
    row.page = page;
    history.push({
      pathname: editUserPath,
      state: row,
      string: "executivelist",
    });
  };

  const getStatus = (e, id, status) => {
    const updateData = {
      emp_id: id,
      action: status,
    };
    http
      .patch("/dashboardupdateview", updateData)
      .then((res) => {
        toast.success(res.data.Data);
      })
      .catch((err) => {
        // (err);
      });
  };

  let curr = new Date();
  curr.setDate(curr.getDate());
  let getCurrentdate = curr.toISOString().substring(0, 10);
  return (
    <Paper>
      <div className="prospectsearchfilterboth">
        <div className="prospectsearch">
          <SearchBar
            value={searched}
            onChange={(searchVal) => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            style={{ height: "unset", padding: "5px", marginTop: 5 }}
          />
        </div>

        <div style={{ display: "flex" }}>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
            component="div"
            count={listData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p>Filter</p>
            <FilterLogo
              onClick={showexefilter}
              style={{ cursor: "pointer", marginLeft: 5 }}
            />
            <div
              style={{ display: showFilterExe ? "block" : "none" }}
              className="exefilter"
            >
              <div className="cancelexe">
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    lineHeight: "30px",
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bold",
                    cursor: "pointer",
                    background: "#ddd",
                    margin: "5px 0 0 5px",
                  }}
                  onClick={cnacelSearch}
                >
                  X
                </div>
              </div>

              <h4 className="exelabel">Date</h4>

              <label className="exelabel">From</label>
              <input
                type="date"
                alt="date"
                onChange={dateHandleChange}
                name="from"
                value={statFilter.from}
                max={getCurrentdate}
                className="exeinput"
              />

              <label className="exelabel">To</label>
              <input
                type="date"
                alt="date"
                onChange={dateHandleChange}
                name="to"
                value={statFilter.to}
                max={getCurrentdate}
                className="exeinput"
              />

              <label className="exelabel">Name</label>
              <select
                value={statFilter.names}
                name="names"
                onChange={dateHandleChange}
                className="exeinput"
                style={{
                  backgroundColor: "white",
                  marginBottom: 10,
                }}
              >
                <option value="">Select</option>
                {nameDropdown.map((item) => (
                  <option value={item.empfname}>{item.empfname}</option>
                ))}
              </select>

              <Button
                variant="outlined"
                color="primary"
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  marginTop: "30px",
                }}
                onClick={dateHandleClear}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "30px" }}
                onClick={getDashboardDatas}
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: " #fafafa" }}>
              {columns.map((column, index) => (
                <TableCell>{column.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {listData.length !== 0 ? (
              <>
                {listData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    // (row);
                    return (
                      <TableRow hover>
                        {columns.map((column, index) => {
                          // (column.status);
                          const empid = row.id;
                          var statval = "";
                          const status = row.status;
                          if (status === true) {
                            statval = 0;
                          } else {
                            statval = 1;
                          }
                          // (statval);
                          const value = row[column.id];
                          // (value);
                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                            >
                              {column.format &&
                              column.format === "boolean" &&
                              !value ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      padding: "2px 5px",
                                      border: "1px solid #2835d5",
                                      color: "#fff",
                                      display: "flex",
                                      borderRadius: "5px",
                                      alignItems: "center",
                                      background: "#2835d5",
                                      height: "30px",
                                    }}
                                    onClick={(e) =>
                                      getStatus(e, empid, statval)
                                    }
                                  >
                                    <p>Resume</p>
                                    <PlayCircleOutlineOutlinedIcon
                                      style={{
                                        color: "#fff",
                                        cursor: "pointer",
                                        marginLeft: 10,
                                      }}
                                    />
                                  </div>
                                  {/* <EditOutlinedIcon
                                      style={{
                                        color: "#2835d5",
                                        cursor: "pointer",
                                        marginLeft: 10,
                                      }}
                                      onClick={(e) => EditUser(e, row)}
                                    /> */}
                                </div>
                              ) : column.format &&
                                column.format === "boolean" &&
                                value ? (
                                <div
                                  style={{ display: "flex", cursor: "pointer" }}
                                >
                                  <div
                                    style={{
                                      padding: "2px 5px",
                                      border: "1px solid #2835d5",
                                      color: "#2835d5",
                                      display: "flex",
                                      borderRadius: "5px",
                                      alignItems: "center",
                                      height: "30px",
                                    }}
                                    onClick={(e) =>
                                      getStatus(e, empid, statval)
                                    }
                                  >
                                    <p>Pause</p>
                                    <PauseCircleIcon
                                      style={{
                                        color: "#2835d5",
                                        cursor: "pointer",
                                        marginLeft: 10,
                                      }}
                                    />
                                  </div>
                                  {/* <EditOutlinedIcon
                                    style={{
                                      color: "#2835d5",
                                      cursor: "pointer",
                                      marginLeft: 10,
                                    }}
                                    onClick={(e) => EditUser(e, row)}
                                  /> */}
                                </div>
                              ) : column.id === "languages" ? (
                                value && value.length > 0 ? (
                                  value.toString()
                                ) : (
                                  "N/A"
                                )
                              ) : column.id === "source" ? (
                                value && value.length > 0 ? (
                                  value.toString()
                                ) : (
                                  "N/A"
                                )
                              ) : column.id === "Total Call Duration in mins" ||
                                column.id === "% Conversion" ? (
                                value.toFixed(2)
                              ) : column.label === "reporting" ? (
                                value ? (
                                  value
                                ) : (
                                  "N/A"
                                )
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </>
            ) : (
              <TableCell
                colspan="15"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                Records Not Available
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default Executivelist;
